// extracted by mini-css-extract-plugin
export default {"candidateTable":"styles_candidateTable__oTKEO","customBox":"styles_customBox__OiRf0","contentBox":"styles_contentBox__DKNXw","headingBox":"styles_headingBox__jk8Ft"};